import { Button, Popconfirm, Space, Spin, Tooltip } from "antd";
import { t } from "i18next";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

type EditDeleteActionsProps = {
  onEdit?: () => void;
  loadingEdit?: boolean;
  onDelete?: () => void;
  loadingDelete?: boolean;
};

function EditDeleteActions(props: EditDeleteActionsProps) {
  return (
    <Space size={8}>
      <Tooltip title={t("button.edit")}>
        <Button
          type="text"
          icon={props.loadingEdit ? <Spin size="small" /> : <EditOutlined />}
          onClick={props.onEdit}
          disabled={!props.onEdit || props.loadingEdit}
          aria-label={t("button.edit")}
        />
      </Tooltip>

      <Popconfirm
        title={t("message.confirm_delete")}
        description={t("message.confirm_delete_description")}
        okText={t("button.confirm")}
        cancelText={t("button.cancel")}
        onConfirm={props.onDelete}
        disabled={!props.onDelete || props.loadingDelete}
      >
        <Tooltip title={t("button.delete")}>
          <Button
            danger
            type="text"
            icon={
              props.loadingDelete ? <Spin size="small" /> : <DeleteOutlined />
            }
            disabled={!props.onDelete || props.loadingDelete}
            aria-label={t("button.delete")}
          />
        </Tooltip>
      </Popconfirm>
    </Space>
  );
}

export default EditDeleteActions;
